// src/hooks/useTranslations.ts
import { useTranslation as useI18nTranslation } from 'react-i18next';

export function useTranslation() {
  return useI18nTranslation();
}
